<ag-grid-dynamic #grid [columns]="columns" [options]="options" [getRowData]="prepareLoadData.bind(this)"
    [(loadDataParameters)]="loadDataParameters" [sumHeaderText]="collectionName" (rowDoubleClickedEvent)="onRowDoubleClicked($event)"
    [searchText]="searchText">
</ag-grid-dynamic>
